import React from 'react';
import { IDeleteActivityLogDialog } from './interfaces';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { useDeleteActivityLog } from '../../../../reactQuery/Activities/activities';
import { enqueueSnackbar } from 'notistack';
import { ROUTES } from '../../../../routes/Routes';
import { useNavigate } from 'react-router';

export const DeleteActivityLogDialog: React.FC<IDeleteActivityLogDialog> = ({
  show,
  onClose,
  activityLogId,
}): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { mutate: deleteActivityLog, isLoading: isDeletingActivityLog } =
    useDeleteActivityLog();

  const onDeleteActivityLog = (): void => {
    deleteActivityLog(activityLogId, {
      onSuccess: () => {
        enqueueSnackbar(t('activities:prompts.deleteActivityLog.success'), {
          variant: 'success',
        });
        navigate(ROUTES.activityLog.overview);
      },
      onError: () => {
        enqueueSnackbar(t('activities:prompts.deleteActivityLog.failed'), {
          variant: 'error',
        });
      },
    });
  };

  return (
    <Dialog open={show}>
      <DialogTitle fontWeight="bold">
        {t('activities:prompts.deleteActivityLog.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          <Trans
            i18nKey="activities:prompts.deleteActivityLog.body"
            components={{ strong: <strong /> }}
          />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={onClose}
          color="primary"
          disabled={isDeletingActivityLog}
        >
          {t('buttons.cancel')}
        </Button>
        <Button
          onClick={onDeleteActivityLog}
          color="error"
          variant="contained"
          disabled={isDeletingActivityLog}
        >
          {t('buttons.delete')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
